const LINK_PREFIX = '#modal-';

/** @param {HTMLDialogElement} modalEl */
export const openModal = (modalEl) => {
    if (modalEl) {
        modalEl.showModal();
        document.body.classList.add('no-scroll');
        if (modalEl.querySelector('.ra__player')) {
            window.dispatchEvent(new Event('resize'));
        }
    }
};

export const handleModalClose = () => {
    window.dispatchEvent(new CustomEvent('pauseVideo'));
    if (window.vidyardEmbed) {
        const { players } = window.VidyardV4;
        players[0].pause();
    }
    document.body.classList.remove('no-scroll');
};

/**
 * @param {MouseEvent} ev
 */
const handleModalLinkClick = (ev) => {
    ev.preventDefault();
    const modalEl = document.querySelector(`dialog${ev.currentTarget.getAttribute('href')}`);
    openModal(modalEl);
};

const linkEls = document.querySelectorAll(`[href^="${LINK_PREFIX}"]`);
linkEls.forEach((linkEl) => {
    linkEl.addEventListener('click', handleModalLinkClick);
});

const modalEls = document.querySelectorAll('dialog.modal-container__dialog');
modalEls.forEach((modalEl) => {
    modalEl.addEventListener('close', handleModalClose);
    modalEl.querySelector('.modal-container__backdrop').addEventListener('click', () => modalEl.close());
    modalEl.querySelectorAll('a')
        .forEach((linkEl) => linkEl.addEventListener('click', () => modalEl.close()));
});
